<script>
  /* Executable code section of the program */
  //Components importation
  import Loader from "../components/Loader.svelte";
  import MeetingModal from "../components/Modals/NetworkingBreakModal.svelte";
  import OnetoOneMeetModal from "../components/Modals/OnetoOneMeetModal.svelte";
  import AttendeeCarousel from "../components/AttendeeCarousel.svelte";
  import CellphoneCarouselAttendees from "../components/CellphoneCarouselAttendees.svelte";
  import ChatModal from "../components/Modals/ModalChat.svelte";
  import CustomTableModal from "../components/Modals/CustomTableModal.svelte";
  //Tool importation
  import {
    isModalMeetingsOn,
    isModalUpdate,
    temporalData,
    isOnetoOneMeetingsOn,
    userLocalData,
    isProtectedRoute,
    currentEvent,
    isChatModalOn,
    isCustomTableModalOn,
    isUpdateTableModal,
    userRealTime,
    isPollModalOn,
    isUpdatingPollsModal,
    isAlertOn,
    eventRealTime,
    meetsArray,
  } from "../apis/storage";
  import {
    getOneDocument,
    auth,
    listenToDocument,
    getSpecificDocuments,
  } from "../apis/APIS";
  import { onMount, onDestroy } from "svelte";
  import { navigate } from "svelte-routing";
  import { onAuthStateChanged } from "firebase/auth";
  import CustomTableManage from "./AdminPages/CustomTableManage.svelte";
  import PollsForm from "../components/PollsForm.svelte";
  import MeetingsAdminComponent from "../components/MeetingsAdminComponent.svelte";
  import ContainerSchedulMeets from "../components/ContainerSchedulMeets.svelte";
  import PollsModal from "../components/Modals/PollsModal.svelte";
  import AlertModal from "../components/Modals/AlertModal.svelte";

  // Auxiliary variables
  let event;
  let isloadPage = false;
  let eventWallpaper = "";
  let colorBtn = "";
  let pathname = "";
  let windowWidth = window.innerWidth;
  let isActivePolls
  let hiddenTime = null;
  let finalButtons 
  let isActiveMeetButton

  //Listener variables
  let unsubscribeUser;
  let unsubscribeEvent;

  //Funtion to filter custom buttons
  const filterButtons = () => {
  return event.eventButtons.filter((element) => {
    if (!element.isAvailable) return false;

    if (
      element.buttonTittle === "Meetings" &&
      $userLocalData[0].userRole === "attendee" &&
      !$userRealTime.availableMeet
    ) {
      return false;
    }

    return true;
  });
};
  //Function to go back
  const goBack = () => {
    window.history.back();
  };

  onMount(async () => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        
    window.scrollTo({ top: 0, behavior: "smooth" });
        /* Function to listen the visibility of the page */
        document.addEventListener("visibilitychange", () => {
          const now = Date.now();

          if (document.visibilityState === "hidden") {
            hiddenTime = now;
          } else if (document.visibilityState === "visible") {
            if (hiddenTime && now - hiddenTime > 10 * 60 * 1000) {
              location.reload();
            }
          }
        });

        pathname = window.location.pathname.split("/")[2];
        //Get even information
        unsubscribeEvent = listenToDocument(
          "events",
          pathname,
          (data) => {
            event = data
        $temporalData = event;
        eventWallpaper = event.eventMultimedia.eventWallpaperUrl || "";
        colorBtn = event.colorEvent || "";
        $eventRealTime = event;
        $currentEvent = event.tittle;
        /* meetButton = event.eventButtons.filter(element => element.buttonTittle === "Meet" || element.buttonTittle === "Meetings");
        meetButton = meetButton.length > 0 ? meetButton : [{isAvailable:false}]; */

        isActiveMeetButton = event.eventButtons.some((element) =>{
          return (element.buttonTittle === "Meetings")  &&
          element.isAvailable 
          });
          
        //Polls active verificator
         isActivePolls = event.eventButtons.some((element) => element.buttonTittle === "Polls" && element.isAvailable);

        //Funtion to filter custom buttons
        finalButtons = filterButtons();
        
          }
        );
        /* event = await getOneDocument("events", pathname); */
        //Get local user
        $userLocalData = await getSpecificDocuments("users","email",user.email);
        //Get current user
        $userRealTime = $userLocalData[0]
        
        //Listener for meets
        unsubscribeUser = listenToDocument(
          "users",
          $userLocalData[0].id,
          (data) => {
            $userRealTime = data;
            $meetsArray = $userRealTime.scheduledMeetings;
          }
        );

        setTimeout(() => {
          isloadPage = true;
        }, 1500);
      } else {
        navigate("/");
      }
    });
  });
  onDestroy(() => {
    if (unsubscribeUser) unsubscribeUser(); // Clean listener
    if (unsubscribeEvent) unsubscribeEvent() // Clean listener
  });
  /* End of the section */
</script>

<!-- Section to place the HTML code -->
{#if $isProtectedRoute}
  <body>
    {#if isloadPage}
      <section class="pageContainer">
        <div class="backBtnContainer">
          <button class="backBtn" on:click={goBack}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-arrow-left"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
              />
            </svg> Go Back</button
          >
        </div>

        <!-- Header page -->
        <div
          class="headerInformation"
          style="--event-Wallpaper: {eventWallpaper}; background-image: url({eventWallpaper});"
        >
          <div class="imgContainer">
            <img src={event.eventMultimedia.eventImgUrl} alt="event poster" />
          </div>
          <div class="meetingsBtns">
            <button
              class="actionBtn"
              on:click={() => navigate(`/myChats/${event.id}`)}
              on:keypress={() =>
                navigate(`/myChats/${event.id}/${event.tittle}`)}
              style="--event-color: {colorBtn};">Chats</button
            >
            {#each event.eventButtons as button}
            {#if button.isAvailable}
            {#if $userRealTime.userRole !== "attendee"}
            {#if button.buttonUrl.slice(0, 1) === "#"}
              <button
                on:click={()=>document.getElementById(`${button.buttonUrl.slice(1)}`).scrollIntoView({ behavior: "smooth" })}
                on:keypress={document
                  .getElementById(`${button.buttonUrl.slice(1)}`)
                  .scrollIntoView({ behavior: "smooth" })}
                class="actionBtn"
                style="--event-color: {colorBtn};"
                >{button.buttonTittle}
              </button>
            {:else}
              <a href={button.buttonUrl} target="_blank" rel="noopener noreferrer">
                <button class="actionBtn" style="--event-color: {colorBtn};"
                  >{button.buttonTittle}
                </button>
              </a>
            {/if}
          {:else if !button.isAssignedButton}
          {#if button.buttonUrl.slice(0, 1) === "#"}
              <button
                on:click={()=>document.getElementById(`${button.buttonUrl.slice(1)}`).scrollIntoView({ behavior: "smooth" })}
                on:keypress={document
                  .getElementById(`${button.buttonUrl.slice(1)}`)
                  .scrollIntoView({ behavior: "smooth" })}
                class="actionBtn"
                style="--event-color: {colorBtn};"
                >{button.buttonTittle}
              </button>
            {:else}
            <a href={button.buttonUrl} target="_blank" rel="noopener noreferrer">
              <button class="actionBtn" style="--event-color: {colorBtn};"
                >{button.buttonTittle}
              </button>
            </a>
            {/if}
          {:else if button.isAssignedButton && $userRealTime.customButtons.includes(button.id)}
            <a href={button.buttonUrl} target="_blank" rel="noopener noreferrer">
              <button class="actionBtn" style="--event-color: {colorBtn};"
                >{button.buttonTittle}
              </button>
            </a>
          {/if}
            {/if}
              
            {/each}
          </div>
        </div>
        <!-- End Section -->

        <!-- Event information -->
        <div class="eventInformation">
          <div class="videoSection">
            <iframe
              title="vimeo-player"
              src={event.eventMultimedia.eventVideoUrl}
              width="540"
              height="260"
              frameborder="0"
              allowfullscreen
            ></iframe>
          </div>
          <div class="descriptionContainer">
            <h5>{event.tittle}</h5>
            <p>{event.eventDescription}</p>
          </div>
        </div>
        <!-- End Section -->

        <!-- Breaks Meetings Section -->
         
        {#if $userLocalData[0].userRole !== "attendee" || ($userRealTime.availableMeet && isActiveMeetButton)}
          <div class="meetingContainer" id="meetings">
            <h1 class="subtittle">Meetings</h1>
            {#if $userLocalData[0].userRole !== "attendee"}
              <MeetingsAdminComponent {event} {colorBtn} />
            {:else}
              <ContainerSchedulMeets {colorBtn} />
            {/if}
          </div>
        {/if}

        <!-- End Section -->

        <!-- Custom Tables Section -->
        {#if $userLocalData[0].userRole !== "attendee"}
          <div class="customTablesSection">
            <h1 class="subtittle">Custom Tables</h1>
            <div class="tableContainer">
              <CustomTableManage currentEvent={event} />
            </div>
          </div>
        {/if}
        <!-- End Section -->

        <!-- Social Section -->
        <div class="attendeesSection" id="attendees">
          <h1 class="subtittle">Attendees</h1>
          {#if windowWidth > 700}
            <AttendeeCarousel curretEvent={event.tittle} color={colorBtn} />
          {:else}
            <CellphoneCarouselAttendees
              curretEvent={event.tittle}
              color={colorBtn}
            />
          {/if}
        </div>

        <!-- End Section -->

        <!-- Polls section -->
        {#if isActivePolls || $userLocalData[0].userRole !== "attendee"}
          <div class="pollsSection" id="polls">
            <h1 class="subtittle">Polls</h1>
            <div class="containerForm">
              <PollsForm />
            </div>
          </div>
        {/if}

        <!-- End Section -->
      </section>
    {:else}
      <Loader />
    {/if}
  </body>
  {#if $isModalMeetingsOn || $isModalUpdate}
    <MeetingModal />
  {/if}
  {#if $isOnetoOneMeetingsOn}
    <OnetoOneMeetModal />
  {/if}
  {#if $isChatModalOn}
    <ChatModal />
  {/if}
  {#if $isCustomTableModalOn || $isUpdateTableModal}
    <CustomTableModal />
  {/if}
  {#if $isPollModalOn || $isUpdatingPollsModal}
    <PollsModal />
  {/if}
  {#if $isAlertOn}
    <AlertModal />
  {/if}
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  body {
    width: 100%;
    height: auto;
    min-height: 80vh;
    background-color: #f4f4f4;
    display: flex;
    justify-content: center;
    padding: 30px;
  }
  .pageContainer {
    background-color: white;
    width: 90%;
    height: 100%;
  }
  /* Back Button styles */
  .backBtnContainer {
    width: 100%;
    padding: 20px 0;
    display: flex;
    justify-content: flex-start;
    background-color: #f4f4f4;
  }
  .backBtn {
    background-color: #f4f4f4;
    border: none;
  }
  .backBtn:hover {
    color: #ed2824;
    border-bottom: 1px solid #ed2824;
  }
  /* Hedaer styles */
  .headerInformation {
    width: 100%;
    height: auto;
    background-size: cover;
    background-position: center;
    display: flex;
    padding: 25px;
  }
  .imgContainer {
    width: 70%;
  }
  .meetingsBtns {
    background-color: rgba(0, 0, 0, 0.425);
    width: 70%;
    max-height: 50vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin: 0;
  }
  .actionBtn {
    width: 200px;
    height: 50px;
    font-size: 20px;
    font-weight: 400;
    border-radius: 12px;
    padding: 8px 16px;
    color: var(--event-color);
    border: 1px solid var(--event-color);
    transition: all 0.3s ease-in-out;
    margin: 0 10px;
    background-color: white;
  }

  .actionBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: var(--event-color);
    color: White;
  }
  img {
    width: 85%;
    height: auto;
  }
  .eventInformation {
    display: flex;
    padding: 30px;
  }
  .descriptionContainer {
    padding: 30px 50px;
    text-align: justify;
    width: 40%;
    border-bottom: 1px solid gray;
  }
  .videoSection {
    padding: 30px 0;
    width: 50%;
    display: flex;
    justify-content: center;
  }
  .meetingContainer {
    padding: 30px;
  }
  .subtittle {
    margin: 25px;
    width: 90%;
    padding: 20px 30px;
    border-bottom: 1px solid gray;
  }
  /* Custom tables styles */
  .tableContainer {
    width: 100%;
    height: auto;
    max-height: 60dvh;
    overflow: auto;
    display: flex;
    justify-content: center;
    padding: 10px;
  }
  .containerForm {
    padding: 30px;
    display: flex;
    justify-content: center;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    body {
      padding: 0;
    }
    .meetingsBtns {
      background-color: rgba(0, 0, 0, 0.425);
      width: 100%;
      height: auto;
      max-height: 15dvh;
      overflow: auto;
      display: flex;
      flex-direction: row;
      justify-content: center;
      padding: 10px 0;
    }
    img {
      width: 100%;
      height: auto;
    }
    .actionBtn {
      margin: 5px;
    }
    .eventInformation {
      display: flex;
      padding: 30px;
    }
    .descriptionContainer {
      padding: 30px 50px;
      text-align: justify;
      width: 60%;
      border-bottom: 1px solid gray;
    }
    .videoSection {
      padding: 30px 0;
      width: 50%;
      display: flex;
      justify-content: center;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    body {
      width: 100%;
      padding: 0;
    }
    .pageContainer {
      background-color: white;
      width: 100%;
    }
    .headerInformation {
      width: 100%;
      height: auto;
      max-height: 2000dvh;
      flex-direction: column;
      align-items: center;
      padding: 0;
    }
    .imgContainer {
      width: 100%;
      display: flex;
      justify-content: center;
    }
    .meetingsBtns {
      background-color: rgba(0, 0, 0, 0);
      width: 100%;
      height: auto;
      max-height: auto;
      display: flex;
      flex-direction: row;
      justify-content: center;
      padding: 20px 0;
    }
    .actionBtn {
      width: 150px;
      height: auto;
      font-size: 20px;
      font-weight: 500;
      padding: 10px 0;
      background-color: white;
      margin: 5px;
    }
    .eventInformation {
      flex-direction: column;
      align-items: center;
    }
    .descriptionContainer {
      padding: 10px;
      text-align: justify;
      width: 100%;
      border-bottom: 1px solid gray;
    }
    .videoSection {
      padding: 10px;
      width: 100%;
      display: flex;
      justify-content: center;
    }
    /* Custom tables styles */
    .tableContainer {
      width: 100%;
      height: auto;
      max-height: 30dvh;
      overflow: auto;
      display: flex;
      justify-content: center;
      padding: 10px;
    }
  }

  /* Roots for variables */
  /* :root {
        --event-Wallpaper: {eventWallpaper};
    } */
  /* End of the section */
</style>
